import axiosHttp from "./interceptor.service";

const getTimeLoggerOrgs = () => {
  return axiosHttp.get("/lmt/time-logger-orgs");
};

const getTimeLoggerOrgById = (orgId) => {
  return axiosHttp.get(`/lmt/time-logger-orgs/${orgId}`);
};

const updateTimeLoggerOrg = (orgId, data) => {
  return axiosHttp.put(`/lmt/time-logger-orgs/${orgId}`, data);
};

export { getTimeLoggerOrgs, getTimeLoggerOrgById, updateTimeLoggerOrg };
